// extracted by mini-css-extract-plugin
module.exports = {"root":"nav-card_root__UTGwB","image":"nav-card_image__6GAPg","link":"nav-card_link__U22ou","navCardOverlayOnImage":"nav-card_navCardOverlayOnImage__Sd1AY"};